import styled, { css } from 'styled-components';

import { flexAsColumn, flexAsRow } from '@components/Styled/mixins';

const getCircleBackground = (isBackgroundWhite, theme) => {
  if (isBackgroundWhite) {
    return theme.colors.secondary.lighterBlue;
  }

  return theme.colors.neutral.chromatic[100];
};

const StepperContent = styled.div`
  ${flexAsRow()};

  height: 100%;
  text-align: center;
  padding: ${({ theme }) => theme.spacing(2)};

  ${({ verticalOnMobile, theme }) => verticalOnMobile && css`
    @media screen and (max-width: ${theme.breakpoints.small}px) {
      flex-direction: column;
    }
  `}
`;

const StepIcon = styled.div`
  text-align: left;
  min-width: ${({ theme, hasNextStep }) => (hasNextStep
    ? `${theme.spacing(20)}`
    : 'none')};
  width: ${({ hasNextStep }) => (hasNextStep ? '100%' : '50%')};

  ${({ verticalOnMobile }) => verticalOnMobile && css`
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}px){
      ${flexAsRow(1)};

      min-width: unset;
      min-height: ${({ theme, hasNextStep }) => (hasNextStep
    ? `${theme.spacing(10)}`
    : 'none')};
      width: 100%;
    }
  `}
`;

const IconCircle = styled.div`
  ${flexAsRow()};

  width: ${({ theme }) => theme.spacing(4)};
  justify-content: center;
  height: ${({ theme }) => theme.spacing(4)};
  padding: ${({ theme }) => theme.spacing(0.5)};
  border-radius: 100%;
  background: ${({ theme, status, isBackgroundWhite }) => (status === 'completed'
    ? `${theme.colors.brand.main[100]};`
    : getCircleBackground(isBackgroundWhite, theme))};
  color: ${({ theme, status }) => {
    const colors = {
      inactive: theme.colors.brand.main[900],
      completed: theme.colors.neutral.chromatic[100],
      pending: theme.colors.support.info[500]
    };

    return colors[status];
  }};
`;

const IconBar = styled.div`
  ${flexAsRow()}

  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  border-radius: 50%;
  align-items: ${({ status }) => (status === 'completed' ? 'unset' : 'center')};
  padding: ${({ theme, status }) => (status === 'completed' ? `${theme.spacing(0.5)}` : 0)};
  background: ${({ theme, status, isBackgroundWhite }) => (status === 'completed'
    ? `${theme.colors.brand.main[500]}`
    : getCircleBackground(isBackgroundWhite, theme))};
`;

const IconsLine = styled.div`
  ${flexAsRow()};

  align-items: center;
  width: 100%;

  ${({ verticalOnMobile, theme }) => verticalOnMobile && css`
    @media screen and (max-width: ${theme.breakpoints.small}px) {
      ${flexAsColumn()};

      width: fit-content;
    }
  `}
`;

const VerticalLine = styled.div`
  flex: 1;
  height: 1px;
  border-top: ${({ theme, status }) => (status === 'completed'
    ? `solid ${theme.colors.brand.main[500]}`
    : `dashed ${theme.colors.neutral.chromatic[200]}`)};

  ${({ verticalOnMobile, theme, status }) => verticalOnMobile && css`
    @media screen and (max-width: ${theme.breakpoints.small}px) {
      width: 2px;
      height: ${theme.spacing(3)};
      border-top: none;
      border-left: ${status === 'completed'
    ? `solid ${theme.colors.brand.main[500]}`
    : `dashed ${theme.colors.neutral.chromatic[200]}`};
    }
  `}
`;

const LabelContent = styled.div`
  padding-top: ${({ theme }) => theme.spacing(1)};
  width: ${({ hasNextStep }) => (hasNextStep ? '80%' : '100%')};

  ${({ verticalOnMobile, theme }) => verticalOnMobile && css`
    @media screen and (max-width: ${theme.breakpoints.small}px) {
      padding-top: 0;
    }
  `}
`;

export {
  IconBar,
  IconCircle,
  IconWrapper,
  IconsLine,
  LabelContent,
  StepIcon,
  StepperContent,
  VerticalLine
};
